import { Alert, unit } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledAlert = styled(Alert) `
  margin: ${unit('xl')} 0;
`;
